import { render, staticRenderFns } from "./DetalheTituloRevisao.vue?vue&type=template&id=61a7a377&scoped=true"
import script from "./DetalheTituloRevisao.vue?vue&type=script&lang=js"
export * from "./DetalheTituloRevisao.vue?vue&type=script&lang=js"
import style0 from "./DetalheTituloRevisao.vue?vue&type=style&index=0&id=61a7a377&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a7a377",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a7a377')) {
      api.createRecord('61a7a377', component.options)
    } else {
      api.reload('61a7a377', component.options)
    }
    module.hot.accept("./DetalheTituloRevisao.vue?vue&type=template&id=61a7a377&scoped=true", function () {
      api.rerender('61a7a377', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DetalheTituloRevisao.vue"
export default component.exports